import React from "react"
import BackgroundVideo from "../atoms/BackgroundVideo"
import DatoImage from "../dato/DatoImage"
import * as styles from "./BackgroundMedia.module.scss"

export type BackgroundMediaProps = Queries.DatoMediaFragment

// TODO tämä sisältää Dato ja Gatby riippuvaisia osia. Molekyylien ei tulisi olla sidottuja niihin

const BackgroundMedia = (props: BackgroundMediaProps) => {
  //console.log("Rendering BackgroundMedia", props)

  const mediaType = props.mimeType?.split("/")[0] || (props.video ? "video" : "image")

  return (
    <div className={styles.container}>
      {mediaType == "video"
        ? props.video?.mp4Url && (
            <BackgroundVideo
              className={styles.video}
              src={props.video.mp4Url}
              poster={props.video.thumbnailUrl + "?time=0"} // poster kuva ihan videon alusta
            />
          )
        : props.image && (
            <DatoImage
              className={styles.image}
              image={props.image}
              alt={props.alt || props.title || ""}
              focalPoint={props.focalPoint}
            />
          )}
    </div>
  )
}

export default BackgroundMedia
